import React, { useState, useRef, useEffect } from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';

const SearchBar = ({ onSearch, onFilterToggle, searchValue, setSearchValue }) => {
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [suggestions, setSuggestions] = useState([]);
  const searchRef = useRef(null);

  // Mock autocomplete suggestions
  const mockSuggestions = [
    "COVID-19 vaccine effectiveness",
    "Climate change data manipulation",
    "Election fraud claims 2024",
    "Social media misinformation",
    "Economic statistics accuracy",
    "Healthcare policy claims",
    "Immigration statistics verification",
    "Energy policy fact-check"
  ];

  useEffect(() => {
    if (searchValue?.length > 2) {
      const filtered = mockSuggestions?.filter(suggestion =>
        suggestion?.toLowerCase()?.includes(searchValue?.toLowerCase())
      );
      setSuggestions(filtered?.slice(0, 5));
      setShowSuggestions(true);
    } else {
      setShowSuggestions(false);
    }
  }, [searchValue]);

  const handleSearchSubmit = (e) => {
    e?.preventDefault();
    if (searchValue?.trim()) {
      onSearch(searchValue);
      setShowSuggestions(false);
    }
  };

  const handleSuggestionClick = (suggestion) => {
    setSearchValue(suggestion);
    onSearch(suggestion);
    setShowSuggestions(false);
  };

  const handleInputChange = (e) => {
    setSearchValue(e?.target?.value);
  };

  return (
    <div className="relative w-full max-w-4xl mx-auto">
      <form onSubmit={handleSearchSubmit} className="relative">
        <div className="relative flex items-center">
          <div className="relative flex-1">
            <Input
              ref={searchRef}
              type="search"
              placeholder="Search claims, topics, or paste a link to verify..."
              value={searchValue}
              onChange={handleInputChange}
              className="pr-24 pl-12 py-4 text-lg border-2 border-border focus:border-primary rounded-xl shadow-soft"
            />
            <Icon
              name="Search"
              size={20}
              className="absolute left-4 top-1/2 transform -translate-y-1/2 text-muted-foreground"
            />
          </div>
          
          <div className="absolute right-2 top-1/2 transform -translate-y-1/2 flex items-center space-x-2">
            <Button
              type="button"
              variant="ghost"
              size="icon"
              iconName="SlidersHorizontal"
              onClick={onFilterToggle}
              className="text-muted-foreground hover:text-foreground"
            />
            <Button
              type="submit"
              variant="default"
              size="sm"
              iconName="Search"
              iconPosition="left"
              className="px-4"
            >
              Search
            </Button>
          </div>
        </div>

        {/* Autocomplete Suggestions */}
        {showSuggestions && suggestions?.length > 0 && (
          <div className="absolute top-full left-0 right-0 mt-2 bg-card border border-border rounded-lg shadow-elevated z-50">
            <div className="py-2">
              {suggestions?.map((suggestion, index) => (
                <button
                  key={index}
                  type="button"
                  onClick={() => handleSuggestionClick(suggestion)}
                  className="w-full px-4 py-2 text-left hover:bg-muted transition-smooth flex items-center space-x-3"
                >
                  <Icon name="Search" size={16} className="text-muted-foreground" />
                  <span className="text-sm text-foreground">{suggestion}</span>
                </button>
              ))}
            </div>
          </div>
        )}
      </form>
      {/* Quick Search Tips */}
      <div className="mt-4 flex flex-wrap items-center justify-center gap-2 text-sm text-muted-foreground">
        <span>Try:</span>
        {["COVID-19", "Climate change", "Election 2024"]?.map((tip, index) => (
          <button
            key={index}
            onClick={() => handleSuggestionClick(tip)}
            className="px-3 py-1 bg-muted rounded-full hover:bg-muted/80 transition-smooth"
          >
            {tip}
          </button>
        ))}
      </div>
    </div>
  );
};

export default SearchBar;